import { A_YES_AND_NOT } from "@/src-refactor/modules/shared/model/const/yes-and-not.conts";
import { Grid } from "@mui/material";
import MxFormL3RushRadioDuoField from "@rf-l3/form/MxFormL3RushRadioDuo";
import useHasTrustMeting from "../../hooks/useHasTrustMeting";
import HasMeetingsTrustEntity from "./HasMeetingsTrustEntity";
import useMediaQuery from "@/shared/hooks/use-media-query";
import MxFormL3AutoComplete from "@rf-l3/form/MxForml3AutoComplete";
import { CPropertyValidationDocumentKeys } from "@rf/property/module/components/property-form/util/schemas/validation-documents/validation-document.schema";

const IsNo = () => {
  const { YES } = useHasTrustMeting();
  const { isMobile } = useMediaQuery();

  return (
    <Grid container>
      {!isMobile && (
        <Grid item maxWidth={500} minWidth={500}>
          <MxFormL3RushRadioDuoField
            withreacthookform={1}
            items={A_YES_AND_NOT}
            label="¿Tuvo una reunión con la fiduciaria?"
            name={CPropertyValidationDocumentKeys.trust_has_meeting_trustee}
          />
        </Grid>
      )}
      {isMobile && (
        <Grid item maxWidth={500} minWidth={500}>
          <MxFormL3AutoComplete
            withreacthookform={1}
            items={A_YES_AND_NOT}
            label="¿Tuvo una reunión con la fiduciaria?"
            name={CPropertyValidationDocumentKeys.trust_has_meeting_trustee}
          />
        </Grid>
      )}
      <Grid container item xs={12} mt={2}>
        <Grid item xs={4}>
          {YES && <HasMeetingsTrustEntity />}
        </Grid>
      </Grid>
    </Grid>
  );
};
export default IsNo;
